import { useAjax, useMzMutation } from "@harea/component";

export const useRefuseDayOffMutation = () => {
    const ajax = useAjax();
    return useMzMutation(async (payload: Record<string, any>) =>
        ajax.send({
            type: "POST",
            content_type: "application/json",
            url: `project/dayoff/${payload.id}/refuse`,
            data: {
                reason: payload?.reason
            },
        })
    );
};